export type RuleConditionValue = string | string[]

const LIST_OPERATORS = new Set([
  'contains',
  'not_contains',
  'is_any_of',
  'is_none_of',
])

export const isListOperator = (operator: string): boolean =>
  LIST_OPERATORS.has(operator)

export const asStringArray = (value: RuleConditionValue): string[] => {
  if (Array.isArray(value)) {
    return value.map((v) => v.trim()).filter(Boolean)
  }
  return value.trim() ? [value.trim()] : []
}

export const hasConditionValue = (
  value: RuleConditionValue,
  operator: string
): boolean =>
  isListOperator(operator) ? asStringArray(value).length > 0 : String(value).trim().length > 0

export const formatConditionValueDisplay = (
  value: RuleConditionValue,
  operator: string
): string => {
  if (isListOperator(operator)) {
    const items = asStringArray(value)
    return items.length ? items.map((v) => `"${v}"`).join(', ') : '""'
  }
  return `"${typeof value === 'string' ? value : ''}"`
}

export const emptyConditionValue = (operator: string): RuleConditionValue =>
  isListOperator(operator) ? [] : ''
